export default __webpack_public_path__ + "static/media/junk3.d18006ac.svg";